// import { JobProfileTableStyle } from "./JobProfileTableStyle"

import { JobProfileTableStyle } from "../job-profile-table/JobProfileTableStyle"

export function JobProfileKpisTable({ data, onDelete, onEdit, options }) {
	const items = [
		{
			name: "name",
			label: "Nombre",
			props: {},
		},
		{
			name: "description",
			label: "Description",
		},
		{
			name: "minimum_percentage",
			label: "% Mínimo",
		},
	]

	return <JobProfileTableStyle {...{ items, data, onDelete, onEdit, options }} />
}
